import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SidebarProjectList = props => (
  <ul className={"sidebar-list"}>
    {props.projects.map(p => (
      <li key={p.name}>
        <div className={"sidebar-list-icon-wrapper"}>
          <FontAwesomeIcon icon={p.icon} />
        </div>
        {p.url ? (
          <a href={p.url} target="_blank" rel="noopener noreferrer">
            {p.name}
          </a>
        ) : (
          <span>{p.name}</span>
        )}
      </li>
    ))}
  </ul>
);

SidebarProjectList.propTypes = {
  projects: PropTypes.array.isRequired,
};
